export default __webpack_public_path__ + "static/media/repeat.d789e00a.svg";